import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const StyledModal = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const StyledFade = styled.div`
  position: absolute;
  background-color: black;
  opacity: 0.2;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

interface FrameProps {
  $wide: boolean;
}

export const StyledFrame = styled.div<FrameProps>`
  display: inline-block;
  width: 100%;
  max-width: 37.5rem;
  max-height: calc(100% - 4rem);
  overflow-y: scroll;

  ${(props) =>
    props.$wide &&
    css`
      max-width: 51rem;
    `}
  padding: 2rem;
  border-radius: 0.325rem;
  background-color: white;
  z-index: 1;
`;
